import React from 'react';
import { useHrPayroll } from '../../../contexts/HrPayrollContext';
import { employeeName } from '../../../utils/hrFormat';
type EmployeeSelectProps = {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  includeAllOption?: string;
  currentOnly?: boolean;
};
export function EmployeeSelect({
  id,
  label,
  value,
  onChange,
  includeAllOption,
  currentOnly = true
}: EmployeeSelectProps) {
  const {
    employees
  } = useHrPayroll();
  const list = employees.filter(e => !currentOnly || e.status !== 'Terminated' && e.status !== 'Inactive').sort((a, b) => a.surname.localeCompare(b.surname));
  return <div data-id="element-772" data-mp="2osy8bipfs70t">
      <label htmlFor={id} className="block text-sm font-medium text-slate-700" data-id="element-773" data-mp="2ot6iv3y3708u">{label}</label>
      <select id={id} value={value} onChange={e => onChange(e.target.value)} className="mt-1 block w-full rounded-md border border-slate-300 bg-white p-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-774" data-mp="2tqpxw62lzh1u">
        <option value="" data-id="element-775" data-mp="1xo5azq4hl2ta">{includeAllOption ?? 'Select employee…'}</option>
        {list.map(e => <option key={e.id} value={e.id} data-id="element-776" data-mp="1spbwpvhdl7s2">{employeeName(e)} — {e.employeeNumber}</option>)}
      </select>
    </div>;
}